import React from 'react';
import { ArtistMember, ArtistProfile } from 'types';
import { NewMember } from 'components/Wizard/types';
import { MemberMissingFieldInfo } from './ArtistMembers';
import { TextEmphasis } from '@protonradio/proton-ui';

interface ArtistMembersSubtitleProps {
  artistProfile: ArtistProfile;
  artistMembers: (ArtistMember | NewMember)[];
  viewOnly: boolean;
  getMemberMissingFieldInfo: (member: ArtistMember | NewMember) => MemberMissingFieldInfo;
}

export const ArtistMembersSubtitle: React.FC<ArtistMembersSubtitleProps> = ({
  artistProfile,
  artistMembers,
  viewOnly,
  getMemberMissingFieldInfo
}) => {
  const verifiedMembersWithMissingFields = artistProfile?.members.filter(member => {
    const { missingFields } = getMemberMissingFieldInfo(member);
    return missingFields.length > 0 && member.verified;
  });

  if (verifiedMembersWithMissingFields.length > 0) {
    const multipleMembers = verifiedMembersWithMissingFields.length > 1;

    return (
      <>
        {(() => {
          if (artistMembers.length === 1) return 'This artist member has ';
          return multipleMembers ? 'Some artist members have ' : 'An artist member has ';
        })()}
        already claimed their account, but need{multipleMembers ? '' : 's'} to finish
        adding their details. To move forward, ask the member
        {multipleMembers ? 's' : ''} to visit{' '}
        <a href="https://www.protonradio.com/account">protonradio.com/account</a> with
        their username for <TextEmphasis>{artistProfile.name}</TextEmphasis>. Or for help,
        please contact{' '}
        <a href="mailto:support@protonradio.com">support@protonradio.com</a>, or click the
        chat icon in the bottom right corner.
      </>
    );
  }

  if (viewOnly) {
    return (
      <>
        If you need to make changes to this artist&apos;s member(s), please contact{' '}
        <a href="mailto:support@protonradio.com">support@protonradio.com</a>.
      </>
    );
  }

  return (
    <>
      Please confirm the contact details for the individual members of{' '}
      <TextEmphasis>{artistProfile.name}</TextEmphasis>
    </>
  );
};
